import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "./Legal.css"

function Privacy() {
  return (
    <div className="Privacy">
 
      <div className="Terms__container">
        <h1>Privacy Policy</h1>
        <p>Effective Date: 26 January 2025</p>
        <p>
          Luxury Spain Properties, operated by Pascal BRETEL, values your
          privacy and is committed to protecting your personal data. This
          Privacy Policy explains how we collect, use, and share information
          about you when you visit our website, located at
          www.luxuryspainproperties.com.
        </p>
        <p>
          By using our website, you agree to the collection and use of
          information in accordance with this policy. Please read it carefully
          to understand how your personal data is handled.
        </p>
        <h2>1. Information We Collect</h2>
        <p>We collect information in the following ways:</p>
        <p>
          {" "}
          Personal Information: When you contact us via email or request
          information, we may collect your name, email address, and other
          relevant details. Non-Personal Information: We may collect
          non-identifiable information such as browser type, IP address,
          location, and usage statistics through cookies and tracking
          technologies.
        </p>
        <h2>2. How We Use Your Information</h2>
        <p>
          We use the information we collect for various purposes, including:
        </p>
        <p>
          {" "}
          Providing Services: Responding to inquiries, providing information
          about our properties, and communicating with you about services.
          Website Functionality: Improving our website’s functionality, content,
          and user experience.
        </p>
        <p>
          Marketing: Sending promotional emails or newsletters if you’ve opted
          in to receive them. You may opt-out at any time.
        </p>
        <h2>3. Cookies</h2>
        <p>
          We use cookies to enhance your experience on our website. Cookies are
          small text files that are stored on your device. These cookies help us
          remember your preferences, analyze website traffic, and improve our
          services. You can disable cookies through your browser settings, but
          this may affect your experience on the site.
        </p>
        <h2>4. How We Share Your Information</h2>
        <p>
          We do not sell or rent your personal information to third parties.
          However, we may share your information with:
        </p>
        <p>
          {" "}
          Service Providers: Trusted third-party companies that help us operate
          our website and services (e.g., web hosting, email services). These
          parties are required to maintain the confidentiality of your data.
          Legal Compliance: If required by law or in response to a legal
          process, we may disclose your personal information.
        </p>
        <h3>5. Data Security</h3>
        <p>
          We take reasonable measures to protect your personal information from
          unauthorized access, disclosure, or alteration. However, no method of
          transmission over the internet or electronic storage is 100% secure.
          While we strive to protect your data, we cannot guarantee its absolute
          security.
        </p>
        <h2>6. Your Rights</h2>
        <p>
          Depending on your location, you may have certain rights regarding your
          personal data, including:
        </p>
        <br />
        <p> The right to access the personal data we hold about you.</p>
        <p> The right to correct or update your personal information.</p>
        <p> The right to request the deletion of your personal information.</p>
        <p>
          {" "}
          The right to withdraw consent for processing your data at any time.
        </p>
        <br />
        <p>
          If you wish to exercise any of these rights, please contact us at
          info@luxuryspainproperties.com.
        </p>
        <h2>7. Third-Party Links</h2>
        <p>
          Our website may contain links to third-party websites. We are not
          responsible for the privacy practices of these sites, and this Privacy
          Policy does not apply to them. We encourage you to review the privacy
          policies of any third-party sites you visit.
        </p>
        <h2>8. Changes to This Privacy Policy</h2>
        <p>
          We may update this Privacy Policy from time to time to reflect changes
          in our practices, legal requirements, or technology. Any changes will
          be posted on this page with the updated effective date. We encourage
          you to review this policy periodically to stay informed about how we
          protect your information.
        </p>
        <h2>9. Contact Us</h2>
        <p>
          If you have any questions or concerns about this Privacy Policy or how
          we handle your personal information, please contact us at:
        </p>
        <p>Luxury Spain Properties</p>
        <p>Email: info@luxuryspainproperties.com</p>
        <p>Website: www.luxuryspainproperties.com</p>{" "}
      </div>

    </div>
  );
}

export default Privacy;
